module.exports = __webpack_public_path__ + "static/media/animated_juan.adc6f265.png";